import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_5 = { class: "text-xl leading-none text-[#F99F07]" }

import type { SocialProofProps } from "./SocialProofProps";
import EditableElement from "@/views/page/EditableElement.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SocialProofComopnent',
  props: {
    blockId: {},
    socialProofText: {},
    socialProofImages: {},
    borderColor: {},
    textColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialProofImages.items, (img, index) => {
        return (_openBlock(), _createBlock(EditableElement, {
          key: index,
          blockId: _ctx.blockId,
          "field-name": `socialProofImages_${img.id}`,
          hideable: false,
          "with-padding": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: img.src,
              alt: img.alt,
              style: _normalizeStyle({ borderColor: _ctx.borderColor }),
              class: _normalizeClass(["w-10 h-10 rounded-full border-2 object-cover", { '-mr-4': index !== _ctx.socialProofImages.items.length - 1 }])
            }, null, 14, _hoisted_3)
          ]),
          _: 2
        }, 1032, ["blockId", "field-name"]))
      }), 128))
    ]),
    (!_ctx.socialProofText.isHidden)
      ? (_openBlock(), _createBlock(EditableElement, {
          key: 0,
          blockId: _ctx.blockId,
          "field-name": "socialProofText"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("span", {
                    key: i,
                    class: "star"
                  }, "★")
                }), 64))
              ]),
              _createElementVNode("div", {
                class: "text-sm opacity-70",
                style: _normalizeStyle({ color: _ctx.textColor })
              }, _toDisplayString(_ctx.socialProofText.data.text), 5)
            ])
          ]),
          _: 1
        }, 8, ["blockId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})